import React from "react";
import { Route, RouteProps } from "react-router-dom";
import { SEOData } from "./seo-context";
import usePageSEO from "../../hooks/usePageSEO";

interface SEORouteProps extends RouteProps {
  seoData?: SEOData;
}

/**
 * A wrapper around React Router's Route component that automatically
 * updates SEO data when the route is matched
 */
const SEORoute: React.FC<SEORouteProps> = ({ seoData, children, ...rest }) => {
  // Apply SEO data if provided
  usePageSEO(seoData || {});

  return <Route {...rest}>{children}</Route>;
};

export default SEORoute;
